export default {
  DELETE_LOG: 'alerts/dashboard/DELETE_LOG',
}
